import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import frame82 from '../OrgImages/Frame 82.svg';
import frame83 from '../OrgImages/Frame 83.svg';
import frame84 from '../OrgImages/Frame 84.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgCountryOperationsShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section ref={sectionRef} className='relative h-full w-full overflow-hidden bg-warning-50'>
      <div className='flex h-full w-full items-center justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <h1
              className="m-0 text-display-xl font-bold text-gray-600"
              style={{ position: 'absolute', top: 60, left: 48, width: 590 }}
            >
              The world needs <br />
              bold ideas—across <br />
              every place and <br />
              every sector
            </h1>

            <div
              className='flex gap-5'
              style={{ position: 'absolute', left: 48, top: 400, width: 544 }}
            >
              <img
                src={frame82}
                alt=''
                style={{ width: 170, height: 185 }}
                className='shrink-0'
              />
              <img
                src={frame83}
                alt=''
                style={{ width: 170, height: 185 }}
                className='shrink-0'
              />
              <img
                src={frame84}
                alt=''
                style={{ width: 170, height: 185 }}
                className='shrink-0'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

